<div class="row ng-scope">
  <div class="col-12">





    <div class="row form-group">
      <label class="control-label col-4 ng-binding">Nội dung</label>
      <div class="col-8">
        <textarea type="text" tabIndex="5" rows="6" class="form-control" placeholder="" [(ngModel)]="doituongSelect.NoiDung"></textarea>
      </div>
    </div>




    <div class="row form-group">
      <label class="control-label col-4 ng-binding">Ghi chú</label>
      <div class="col-8">
        <input type="text" tabIndex="5" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu">
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-4 ng-binding">Người tạo</label>
      <div class="col-8">
        <input type="text" tabIndex="6" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-4 ng-binding">Trạng thái</label>
      <div class="col-8">
        <ng-select #slCapTren
                   class="twcol"
                   [tabIndex]="1"
                   [openOnEnter]="false"
                   [items]="inputphanhois"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [(ngModel)]="doituongSelect.PhanHoi">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
    </div>


  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
        <span class="fa fa-check"></span> Hoạt động
      </label>
    </div>-->
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
  </div>

</div>


